<script setup>
import { ref, watchEffect, onMounted } from 'vue';

const sections = ref([]);
const splittedSections = ref([[], []]);
const isClient = ref(false);

const { data, error } = useFetch('/v2/stamps', { key: 'stamps', cache: 'no-cache' });

watchEffect(() => {
  if (error.value) {
    console.error('Erro ao buscar stamps:', error.value);
    return;
  }

  if (!data.value) {
    return;
  }

  if (Array.isArray(data.value)) {
    sections.value = data.value;
    splittedSections.value[0] = data.value.filter((_, key) => !(key % 2));
    splittedSections.value[1] = data.value.filter((_, key) => key % 2);
  } else {
    sections.value = [];
    splittedSections.value = [[], []];
    console.warn('Formato invalido:', data.value);
  }
});
</script>

<template>
  <ClientOnly>
    <template #fallback>
      <!-- Server-side: render nothing to avoid hydration mismatch -->
    </template>
    
    <template #default>
      <hr class="border-brand-background mx-10 xl:mx-44 my-4"
        v-if="isClient && splittedSections.some(arr => arr.length > 0)">

      <!-- Stamps -->
      <div v-if="isClient && splittedSections.some(arr => arr.length > 0)" class="md:flex md:gap-6">
        <div v-if="splittedSections[0]" class="flex flex-col gap-3 flex-1 align-middle text-center px-10"
          :class="splittedSections[1] != '' ? 'xl:items-end' : 'xl:items-center'">
          <div v-for="section in splittedSections[0]" :key="section.title">
            <div class="uppercase font-bold">{{ section.title }}</div>
            <div class="uppercase mb-2 text-xs text-gray-400">{{ section.subtitle }}</div>
            <div class="flex gap-4 justify-center py-2 flex-wrap xl:flex-nowrap  ">
              <img v-for="stamp in section.stamps" :key="stamp.image_url" :src="stamp.image_url" alt=""
                class="max-w-20 max-h-20 sm:max-w-24 sm:max-h-24 hover:opacity-70 transition-all duration-300">
            </div>
          </div>
        </div>
        <div class="hidden md:block border-r border-brand-background" v-if="splittedSections[1] != ''"></div>
        <hr class="border-brand-background mx-10 xl:mx-44 my-4 md:hidden" v-if="splittedSections[1] != ''">

        <div v-if="splittedSections[1] != ''"
          class="flex xl:items-start flex-col gap-3 flex-1 align-middle text-center mt-3 md:m-0 px-10">
          <div v-for="section in splittedSections[1]" :key="section.title">
            <div class="uppercase font-bold">{{ section.title }}</div>
            <div class="uppercase mb-2 text-xs text-gray-400">{{ section.subtitle }}</div>
            <div class="flex gap-4 justify-center py-2 flex-wrap xl:flex-nowrap">
              <img v-for="stamp in section.stamps" :key="stamp.image_url" :src="stamp.image_url" alt=""
                class="max-w-20 max-h-20 sm:max-w-24 sm:max-h-24 hover:opacity-70 transition-all duration-300">
            </div>
          </div>
        </div>
      </div>
      <!-- /Stamps -->
    </template>
  </ClientOnly>
</template>